import React from 'react';
import Modal from "react-modal";

import "./ModalConfirmation.css";

Modal.setAppElement("#root");

export default class ModalConfirmation extends React.Component {
  renderActionBtn() {
    const {handleSubmitModal, txtAction} = this.props;

    return (
      <button
        className="modal-confirmation-btn is-no btn"
        onClick={handleSubmitModal}
      >
        {txtAction}
      </button>
    )
  }

  renderDismissBtn() {
    const {handleCloseModal, txtDismiss} = this.props;

    return (
      <button
        className="modal-confirmation-btn is-yes btn"
        onClick={handleCloseModal}
      >
        {txtDismiss}
      </button>
    );
  }

  render() {
    const {
      description,
      handleCloseModal,
      handleSubmitModal,
      heading,
      isOpen,
      txtDismiss
    } = this.props;

    return (
      <Modal
        className="modal-confirmation"
        contentLabel="Confirmation Modal"
        isOpen={isOpen}
        onRequestClose={handleCloseModal}
        overlayClassName="modal-confirmation-overlay"
      >
        <div className="d-flex flex-column">
          <div className="modal-confirmation-heading">{heading}</div>
          <div className="modal-confirmation-description">{description}</div>
          <div className="d-flex justify-content-end">
            {this.renderDismissBtn()}
            {handleSubmitModal && txtDismiss && this.renderActionBtn()}
          </div>
        </div>
      </Modal>
    );
  }
}
